import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowTypesActionsMenu = ({ row, onEdit, onDelete, hasPermissionDirect }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const checkPermission = hasPermissionDirect || (() => true);

  return (
    <>
      <IconButton onClick={handleOpen} size="medium">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEdit && onEdit(row);
            handleClose();
          }}
        >
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            onDelete && onDelete(row.activity_type_id || row.id);
            handleClose();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

RowTypesActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  hasPermissionDirect: PropTypes.func,
};

export default RowTypesActionsMenu;
